// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baBD9{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100vh;width:100%;background-color:#fff;position:fixed;top:0;left:0;z-index:9999}
.NHht2{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:24px}
.PjTiS{width:300px;height:auto}
.hwZiH{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}
.vxG04{color:#0078d4 !important}
.ZEbsu{font-family:"Inter",sans-serif;font-size:16px;color:#334155;margin:0;text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `baBD9`,
	"content": `NHht2`,
	"logo": `PjTiS`,
	"spinnerWrapper": `hwZiH`,
	"spinner": `vxG04`,
	"message": `ZEbsu`
};
module.exports = ___CSS_LOADER_EXPORT___;
